







































import { Component, Vue } from "vue-property-decorator";
import Pdf from "@/components/Pdf.vue";
import Galery from "@/components/Galery.vue";
import { BIcon, BIconBoxArrowRight } from "bootstrap-vue";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    Pdf,
    Galery,
    BIcon,
    BIconBoxArrowRight,
    Header,
    Menu,
    NextPrevBtn,
    Footer,
  },
})
export default class CVKeys extends Vue {
  protected galeryCV: string[] = [
    "/picture_cv/fundamentals_CV_Keys.png",
    "/picture_cv/fundamentals_CV_Grid.png",
    "/picture_cv/fundamentals_CV_Classic.png",
  ];

  protected pdfCV = [
    {
      PdfLink: "/pdf_cv/fundamentals_CV_Keys.pdf",
      PdfDownload: "Fiche 1 : Les 10 points clés",
      TxtPdf: "Fiche 1 : Les 10 points clés",
    },
    {
      PdfLink: "/pdf_cv/fundamentals_CV_Classic.pdf",
      PdfDownload: "Fiche 2 : La grille d’analyse du CV",
      TxtPdf: "Fiche 2 : La grille d’analyse du CV",
    },
    {
      PdfLink: "/pdf_cv/fundamentals_CV_Grid.pdf",
      PdfDownload: "Fiche 3 : Modèle de trame classique",
      TxtPdf: "Fiche 3 : Modèle de trame classique",
    },
  ];
    protected nxtprevCVFundamentals =
  {
    BoolPrev: false,
    BoolNext: true,
    PrevImage: "",
    NextImage: "/thumbnail1.png",
    PrevLink: "",
    NextLink: "/CV/Astuces",
  };
}
